module.exports = __webpack_public_path__ + "static/media/circle_loader.70ffb2b6.gif";